export const SUCCESS = 'SUCCESS';
export const FAILED = 'FAILED';
export const ERROR = 'ERROR';
